<template>
  <div>
    <v-app id="keep">
      <router-view></router-view>
    </v-app>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>